import * as React from 'react';
export const IcTimezones = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17 11a4 4 0 100-8 4 4 0 000 8zm-1.5-5a1 1 0 012 0v.78l.82.27A1 1 0 0119 8.32 1 1 0 0118 9a1.25 1.25 0 01-.32 0l-1.5-.5a1 1 0 01-.68-.95V6zM7 3a4 4 0 100 8 4 4 0 000-8zm1 5.5H6.5a1 1 0 01-1-1V6a1 1 0 012 0v.5H8a1 1 0 010 2zm9 4.5a4 4 0 100 8 4 4 0 000-8zm1 4.5h-.5v.5a1 1 0 01-2 0v-1.5a1 1 0 011-1H18a1 1 0 010 2zM7 13a4 4 0 100 8 4 4 0 000-8zm1.5 4.5a1 1 0 01-.68.95l-1.5.5c-.104.03-.212.047-.32.05a1 1 0 01-.949-1.446 1 1 0 01.579-.504l.82-.27V16a1 1 0 112 0l.05 1.5z'
      fill='currentColor'
    />
  </svg>
);
